import { CustomPaging } from "@/app/components/swipersComponents";
import React, { useState } from "react";
import { GrNext, GrPrevious } from "react-icons/gr";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

interface InfoCardProps {
  icon: string;
  title: string;
  content: string;
}

const InfoCard: React.FC<InfoCardProps> = ({ icon, title, content }) => {
  return (
    <div className="flex grow shrink gap-4 justify-center items-center px-4 bg-white rounded-2xl min-h-[110px] shadow-[0px_0px_16px_rgba(0,0,0,0.17)] w-full max-md:px-5 ">
      <div className="flex gap-4 items-center pr-4 h-full border-r-2 border-zinc-500 min-w-[240px] w-1/2">
        <img loading="lazy" src={icon} alt="icon" className="w-12" />

        <div className=" my-auto text-lg leading-snug text-red-600">
          {title}
        </div>
      </div>
      <div className="w-full text-sm  text-zinc-600">{content}</div>
    </div>
  );
};
const InfoCardMobile: React.FC<InfoCardProps> = ({ icon, title, content }) => {
  return (
    <div className="w-full p-4 mt-auto lg:h-96  md:h-48 ">
      <div className="w-full gap-3 text-center border-red-600 flex flex-col items-center just border-2 rounded-2xl p-4 h-full">
        <img loading="lazy" src={icon} alt="icon" className="w-16 p-2 -mt-12" />
        <div className="h-fit  flex flex-col gap-3">
          <p className=" text-lg leading-snug text-red-600">{title}</p>
          <p className="w-full text-sm  text-zinc-600">{content}</p>
        </div>
      </div>
    </div>
  );
};

const InfoCards: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  function SampleNextArrow(props: any) {
    const { onClick } = props;
    return (
      <div
        className={
          " absolute h-fit bg-gray-500 text-neutral-100 p-2 px-3 w-fit rounded-full inset-0 mt-auto ml-auto -mb-10 sm:-mb-16"
        }
        onClick={onClick}
      >
        <GrNext size={16} />
      </div>
    );
  }

  function SamplePrevArrow(props: any) {
    const { onClick } = props;
    return (
      <div
        className={
          " absolute z-20 bg-gray-500 text-neutral-100 p-2 px-3 w-fit h-fit rounded-full inset-0 mt-auto mr-auto -mb-10 sm:-mb-16"
        }
        onClick={onClick}
      >
        <GrPrevious size={16} />
      </div>
    );
  }
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setCurrentIndex(newIndex);
    },
    customPaging: (index: number) => {
      return (
        <CustomPaging
          key={"pagging-service-consorcio" + index}
          index={index}
          currentIndex={currentIndex}
        />
      );
    },
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  const infoCardsData = [
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Consorcio/Property%201=Grupo.svg",
      title: "Grupo",
      content:
        "Ao aderir o Consórcio Toyota, você passa a fazer parte de um grupo de pessoas físicas e jurídicas, que contribuem com parcelas mensais, com o mesmo objetivo: adquirir o carro dos sonhos.",
    },
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Consorcio/Property%201=Fundo%20Comum.svg",
      title: "Fundo Comum",
      content:
        "É um percentual do pagamento mensal de todos os consorciados. Utilizamos nas assembleias, como saldo para aquisição do seu carro novo.",
    },
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Consorcio/Property%201=Assembleias.svg",
      title: "Assembleias",
      content:
        "As assembleias definem os consorciados contemplados no mês. Pagando regularmente as parcelas, até o fim do plano, todos os participantes são contemplados.",
    },
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Consorcio/Property%201=Contempla%C3%A7%C3%A3o.svg",
      title: "Contemplação",
      content:
        "Mensalmente, você poderá ser sorteado ou ofertar um lance. Sendo contemplado, você recebe a carta de crédito para realizar o seu sonho.",
    },
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Consorcio/Property%201=Fundo%20Comum.svg",
      title: "Fundo Comum",
      content:
        "É um percentual do pagamento mensal de todos os consorciados. Utilizamos nas assembleias, como saldo para aquisição do seu carro novo.",
    },
    {
      icon: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Consorcio/Property%201=cart%C3%A3o%20de%20cr%C3%A9dito.svg",
      title: "Fundo Utilizando o crédito",
      content:
        "É um percentual do pagamento mensal de todos os consorciados. Utilizamos nas assembleias, como saldo para aquisição do seu carro novo.",
    },
  ];

  return (
    <>
      <section className="flex flex-wrap max-lg:hidden gap-4 items-start mt-4 w-full max-md:max-w-full">
        {infoCardsData.map((card, index) => (
          <InfoCard
            key={"paging.infoCards.desk" + index}
            icon={card.icon}
            title={card.title}
            content={card.content}
          />
        ))}
      </section>
      <section className="lg:hidden my-20 flex flex-col customSlickFlex ">
        <Slider {...settings}>
          {infoCardsData.map((card, index) => (
            <InfoCardMobile
              key={"paging.infoCards.mbl" + index}
              icon={card.icon}
              title={card.title}
              content={card.content}
            />
          ))}
        </Slider>
      </section>
    </>
  );
};

export default InfoCards;
